import { BaseControl } from "@cloudpivot/form/src/common/controls/base-control";
export class InputControl extends BaseControl {
    get placeholder() {
        return this.controlOpts.placeholder || '';
    }
}
